/**
 * AddGroupCard component
 * Card shown last in the groups grid; opens the Create Group modal on press.
 * Uses ActionCard for consistent styling with InviteCard.
 */

import React from 'react'
import { UsersRound } from 'lucide-react-native'
import { ActionCard } from '../ActionCard/ActionCard'
import { GROUP_CARD_ASPECT_RATIO } from '../FriendCard/FriendCardBase.styles'

interface AddGroupCardProps {
  cardWidth: number
  onPress: () => void
  testID?: string
}

export const AddGroupCard: React.FC<AddGroupCardProps> = ({
  cardWidth: _cardWidth,
  onPress,
  testID = 'add-group-card',
}) => {
  return (
    <ActionCard
      iconName={UsersRound}
      label="Create"
      onPress={onPress}
      aspectRatio={GROUP_CARD_ASPECT_RATIO}
      testID={testID}
    />
  )
}
